import { createStore, applyMiddleware, compose, Middleware, Dispatch, AnyAction } from 'redux';
import {thunk} from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from './slices';
import { configureStore } from '@reduxjs/toolkit';

/**
 * Redux store configuration
 */
const store = configureStore({
  middleware: (getDefaultMiddleware) => {
    const middlewares = getDefaultMiddleware();
    // if (process.env.NODE_ENV === 'development') {
    //   middlewares.push(logger);
    // }
    return middlewares;
  },
  reducer: rootReducer
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
